import '../Sass/App.scss';
import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2';

export function EditInstruction(props) {

    const [instructionData, setInstructionData] = useState({...props.instructionData})
    const [name, setName] = useState(props.instructionData.data.name)
    const [description, setDescription] = useState(props.instructionData.data.description)

    function changeInstruction(event, changer, elem) {
        var newValue = event.target.value
        changer(newValue)
        var newElement = elem
        var newInstructionData = instructionData
        newInstructionData.data[newElement] = newValue
        setInstructionData(newInstructionData)
    }

    return (
            <Grid container spacing={2}> 
                <Grid xs={12} sm={12} md={12} lg={12}>
                    <h4>Edit instruction</h4>
                    <div style={{float: 'left', display: 'block', width: '100%'}}>
                        <div className="codebase-select-div" style={{marginBottom: 10}}>
                            <div className='green-code'>Name</div>
                            <span className='explanation'>Name or title of your instruction. Typically 1-2 words.</span>
                            <input className="codebase-select" value={name} onChange={(e) => changeInstruction(e,setName,'name')} style={{fontSize: '1em', width: '100%'}} />
                        </div>
                        <div className='green-code'>Description</div>
                        <div className="codebase-select-div" style={{marginBottom: 10}}>
                            <textarea rows='4' className="codebase-select" value={description} onChange={(e) => changeInstruction(e,setDescription,'description')} style={{fontSize: '1em', width: '100%'}} />
                        </div>
                    </div>
                    <div style={{width: '100%', float: 'right'}}>
                        <button className="cli-button-white" onClick={() => props.setModifyOpen(false)}>cancel</button>
                        <button className="cli-button" onClick={() => props.changeHandler(instructionData)}>save</button>
                        <div style={{float: 'right'}}><button className="cli-button-red" onClick={() => props.deleteHandler(instructionData)}>delete instruction</button></div>
                    </div>
                </Grid>
            </Grid>
    )
}
